import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { informationCircleOutline, pencilOutline } from 'ionicons/icons';
import { CreateIntentResponse } from 'src/app/services/payment.service';

export enum PaymentState {
  Initialising,
  Initialised,
  ProcessingPayment,
  ConfirmingPayment,
  PaymentConfirmed,
  PaymentComplete
}

export interface PaymentFormViewModel {
  state: PaymentState;
  canEditAmount?: boolean;
  canPayWithGooglePay?: boolean;
  canPayWithApplePay?: boolean;
  intent?: CreateIntentResponse;
  method?: {
    paymentMethodId: string;
    cardBrand: string;
    cardLast4: string;
  };
  error?: string;
}

@Component({
  selector: 'app-student-payment-form-native',
  templateUrl: './student-payment-form-native.component.html',
  styleUrls: ['./student-payment-form-native.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, IonIcon, IonButton]
})
export class StudentPaymentFormNativeComponent {
  @Input() viewModel: PaymentFormViewModel;
  @Output() googlePayment = new EventEmitter<PaymentFormViewModel>();
  @Output() applePayment = new EventEmitter<PaymentFormViewModel>();
  @Output() confirm = new EventEmitter<PaymentFormViewModel>();
  @Output() chooseMethod = new EventEmitter<PaymentFormViewModel>();
  @Output() editAmount = new EventEmitter<PaymentFormViewModel>();

  constructor(public platform: Platform) {
    addIcons({ pencilOutline, informationCircleOutline });
  }

  get amountToPay(): string {
    return (this.viewModel.intent.amount / 100.0).toFixed(2);
  }

  onPayWithGooglePay(): void {
    this.googlePayment.emit(this.viewModel);
  }

  onPayWithApplePay(): void {
    this.applePayment.emit(this.viewModel);
  }

  onConfirm(): void {
    this.confirm.emit(this.viewModel);
  }

  onChooseMethod(): void {
    this.chooseMethod.emit(this.viewModel);
  }

  onEditAmount(): void {
    if (this.viewModel.canEditAmount) {
      this.editAmount.emit(this.viewModel);
    }
  }
}
